<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>微信授权登录</span>
    </header>
    <main>
      <div :class="$style.content">
        <div :class="$style.userInfo" v-if="account">
          <!-- <div :class="$style.avatar">
            <img :src="wechatAvatarIcon" alt="微信头像" />
          </div> -->
          <div :class="$style.username">{{ account }}</div>
          <div :class="$style.tip">点击确认使用此账号登录</div>
        </div>
        
        <div :class="$style.loginBtn" @click="handleLogin">
          <img :src="wechatIcon" :class="$style.btnIcon" />
          <span>微信登录</span>
        </div>
        
        <div :class="$style.otherOptions" v-if="showWechatSelectOther">
          <div :class="$style.divider">
            <span>其他登录方式</span>
          </div>
          <div :class="$style.otherBtn" @click="handleRedirectOther">
            <span>选择其他账号</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import isFullScreen from '@/libs/business/fullScreen';

export default {
  name: 'WechatLogin',
  props: {
    account: {
      type: String,
      default: ''
    },
    showWechatSelectOther: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fullScreen: '',
      wechatIcon: require('@/assets/images/pay/wx.png'),
      wechatAvatarIcon: require('@/assets/images/pay/wx.png')
    }
    // return {
    //   fullScreen: '',
    //   wechatIcon: `${this.$cdnLink}/wanXin/orangeTheme/wechat.png`,
    //   wechatAvatarIcon: `${this.$cdnLink}/wanXin/orangeTheme/wechat.png`
    // }
  },
  created() {
    console.log('wechat login created');
    console.log('this.$cdnLink:', this.$cdnLink);
    this.fullScreen = isFullScreen();
  },
  methods: {
    handleLogin() {
      this.$emit('login');
    },
    handleRedirectOther() {
      this.$emit('redirOther');
    }
  }
}
</script>

<style lang="scss" module>
@import '../../../assets/css/common.scss';

.wrap {
  @include common-window(true);
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
  }
  > main {
    padding-top: 0.3rem;
    .content {
      .userInfo {
        text-align: center;
        margin-bottom: 0.4rem;
        
        .avatar {
          width: 1.2rem;
          height: 1.2rem;
          margin: 0 auto 0.24rem;
          border-radius: 50%;
          overflow: hidden;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        
        .username {
          font-size: 0.32rem;
          font-weight: 500;
          color: #333;
          margin-bottom: 0.08rem;
        }
        
        .tip {
          font-size: 0.24rem;
          color: #999;
        }
      }
      
      .loginBtn {
        @include common-button();
        display: flex;
        // background: #07c160;
        justify-content: center;
        align-items: center;
        
        .btnIcon {
          width: 0.54rem;
          height: 0.54rem;
          margin-right: 0.16rem;
        }
      }
      
      .otherOptions {
        .divider {
          position: relative;
          margin: 0.32rem 0;
          
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            height: 1px;
            background: #e5e5e5;
          }
          
          span {
            background: #fff;
            padding: 0 0.24rem;
            font-size: 0.24rem;
            color: #999;
            position: relative;
            z-index: 1;
          }
        }
        
        .otherBtn {
          width: 4.44rem;
          height: 0.8rem;
          border: 1px solid #e5e5e5;
          border-radius: 0.4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666;
          font-size: 0.28rem;
          margin: 0 auto;
          cursor: pointer;
          transition: all 0.3s;
          
          &:hover {
            border-color: $primary-color;
            color: $primary-color;
          }
          
          &:active {
            background: #f0f9f4;
          }
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > main {
      padding-top: 15px;
      .content {
        .userInfo {
          margin-bottom: 20px;
          
          .avatar {
            width: 60px;
            height: 60px;
            margin: 0 auto 12px;
          }
          
          .username {
            font-size: 16px;
            margin-bottom: 4px;
          }
          
          .tip {
            font-size: 12px;
          }
        }
        
        .loginBtn {
          @include full-screen-button();
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 16px;
          
          .btnIcon {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }
        }
        
        .otherOptions {
          .divider {
            margin: 16px 0;
            
            span {
              padding: 0 12px;
              font-size: 12px;
            }
          }
          
          .otherBtn {
            width: 222px;
            height: 40px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
